<script setup lang="ts">
import DtBtn from './DtBtn.vue';
import DtDialog from './DtDialog.vue';
import { useAppInstall } from '../composables/useAppInstall';

const { showBanner, canInstall, helpOpen, instructions, busy, install, dismiss, closeHelp } = useAppInstall();
</script>

<template>
  <section
    v-if="showBanner"
    class="dt-install-banner"
    aria-label="Instalação do aplicativo"
  >
    <p>Instale o app para abrir a DentisTech direto da tela inicial.</p>
    <div class="dt-install-banner__actions">
      <DtBtn
        :disabled="busy"
        @click="install"
      >
        {{ canInstall ? 'Instalar' : 'Como instalar' }}
      </DtBtn>
      <DtBtn
        variant="quiet"
        aria-label="Ocultar convite de instalação por sete dias"
        @click="dismiss"
      >
        Agora não
      </DtBtn>
    </div>
  </section>
  <DtDialog
    v-if="helpOpen"
    title="Como instalar o app"
    @close="closeHelp"
  >
    <p>{{ instructions }}</p>
    <template #actions>
      <DtBtn @click="closeHelp">
        Entendi
      </DtBtn>
    </template>
  </DtDialog>
</template>

<style scoped>
.dt-install-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--dt-space-sm);
  min-width: 0;
  margin-bottom: var(--dt-space-md);
  padding: var(--dt-space-md);
  border: var(--dt-border-hairline) solid var(--dt-divider);
  border-radius: var(--dt-radius-card);
  background: var(--dt-surface-subtle);
}

.dt-install-banner p {
  flex: 1 1 16rem;
  min-width: 0;
  margin: 0;
  font-size: var(--dt-font-size-md);
  overflow-wrap: anywhere;
}

.dt-install-banner__actions {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--dt-space-xs);
  min-width: 0;
}
</style>
